import React, { useState } from 'react';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import SwiperCarousel, { SwiperSlide } from '@/components/Carousels/SwiperCarousel';

// HELP
import Review from './help/Review';

// STYLES
import { Container } from './styles';

const imagePath = getS3ImageUrl('/home/reviews');

const reviewsData = [
  {
    name: 'Lauren G',
    image: `${imagePath}/Lauren_G.jpg`,
    rating: 5,
    text:
      'I straight love you. I had spent a stupid amount of time trying to figure out how to get tennis channel and espn and was about to give up and call xfinity! Then I stumbled upon your site! Thank you!',
  },
  {
    name: 'Tom J',
    image: `${imagePath}/Tom_J.jpg`,
    rating: 5,
    text:
      'I really found MyBundle to be easy and helpful. This is exactly what I was looking for when I originally cut the cord. Something that would ask for my channels and make recommendations. I had already switched to Youtube TV even though it lacked two channels I wanted: Hallmark and Weather Channel. I was not aware of friendly and am glad to know I can get the missing channels so cheaply.',
  },
  {
    name: 'Michelle R',
    image: `${imagePath}/michelle_r.jpg`,
    rating: 5,
    text:
      "Cool service! Easy to use and turned me onto two products I didn't know about, Locast and Vidgo. I will be subscribing (or donating) to both!",
  },
  {
    name: 'Robert M',
    image: `${imagePath}/Robert_M.jpg`,
    rating: 5,
    text:
      "Pretty awesome web site. exactly what people need. I settled on YouTube TV and Philo and got all the channels I wanted. More people need to know about this site. I'll certainly spread the word.",
  },
  {
    name: 'Jason F',
    image: `${imagePath}/Ross_S.jpg`,
    rating: 5,
    text:
      'The Streaming marketplace is great! Found so many new options to stream and cheap ones too, who knew all these services existed?',
  },
];

const Reviews = () => {
  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);

  const options = {
    onSwiper: setFirstSwiper,
    controller: { control: secondSwiper },
    pagination: { clickable: true },
    loop: true,
    loopedSlides: 4,
    autoHeight: true,
  };

  const thumbOptions = {
    onSwiper: setSecondSwiper,
    controller: { control: firstSwiper },
    navigation: false,
    spaceBetween: 20,
    slidesPerView: 'auto',
    loop: true,
    loopedSlides: 4,
    centeredSlides: true,
    slideToClickedSlide: true,
  };

  return (
    <Container className="section section--deep-dark reviews content-visibility--auto">
      <div className="page-content">
        <div className="reviews__photos-wrap">
          <div className="reviews__photos">
            <SwiperCarousel options={thumbOptions}>
              {reviewsData.map((review, index) => (
                <SwiperSlide key={index}>
                  <img className="reviews__photo" src={review.image} alt={review.name} />
                </SwiperSlide>
              ))}
            </SwiperCarousel>
          </div>
        </div>
        <SwiperCarousel options={options}>
          {reviewsData.map((review, index) => (
            <SwiperSlide key={index}>
              <Review data={review} />
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </div>
    </Container>
  );
};

export default React.memo(Reviews);
